<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="curp">
          <a-input placeholder="Please entercurp" v-decorator="[ 'curp']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Refund Amount">
          <a-input placeholder="Please enter refund amount" v-decorator="[ 'tradeAmt']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Collection Account No.">
          <a-input placeholder="Please enter collection account no." v-decorator="[ 'accountNumber']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="User Name">
          <a-input placeholder="Please enterUser Name" v-decorator="[ 'fullName']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Bank CardType">
          <dict-select
            v-decorator="[ 'accountType']"
            :dict-code="DICT_CODE.BANKACCOUNT_TYPE"
            :placeholder="$t('select')"
          />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Bank CardList">
          <dict-select
            v-decorator="[ 'bankCode']"
            :dict-code="DICT_CODE.BANKNAMELIST"
            :placeholder="$t('select')"
          />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Password">
          <a-input placeholder="Please enterPassword" type="password" v-decorator="[ 'password']"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import {refundTrade} from '@/webpublicapi/order'
import DictSelect from '../../modules/DictSelect';
import md5 from "md5";

// duplicateCheck
export default {
  name: 'RefundTradeModal',
  components: {
    DictSelect,
  },
  mounted(){

    if(typeof FileReader=='undifined')        {
      console.log('Sorry, your browser does not support FileReader');
    }else{
      console.log('FileReader');
    }
  },
  data () {
    return {
      value: 1,
      title: 'Action',
      visible: false,
      visiblekey: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        appSsid: { rules: [{ required: true, message: 'Please enter tenant ID!'}
          ] },
        // firstApprovalM: { rules: [{ required: true, message: 'Please enter package name!' }] },
        // reApprovalM: { rules: [{ required: true, message: 'Please enterlogoUrl!' }] },
        // allApprovalM: { rules: [{ required: true, message: 'Please enterAPPDownload URL!' }] },
      }
    }
  },
  created () {
  },
  methods: {
    add () {
      this.form.resetFields();
      this.visible = true;
    },
    // Confirm
    handleOk () {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          values.password = md5(values.password);
          const formData = Object.assign(this.model, values)

          console.log(formData)

          let obj = refundTrade(formData)

          obj.then((res) => {
            if (res.code === 1000) {
              this.$message.success(res.msg)
              this.$emit('ok')
            } else {
              this.$message.warning(res.msg)
            }
          }).finally(() => {
            this.confirmLoading = false
            this.close()
          })
        }
      })
    },
    // Close
    handleCancel () {
      this.close()
    },

    close () {
      this.$emit('close')
      this.visible = false
    },
  }
}
</script>
